import theme from '@assets/styles/theme'
import { Tab, TabProps, Typography } from '@mui/material'
import { ReactElement } from 'react'

export type TabAppProps = TabProps & {
  selectedValue: string | boolean | number
  value: string | number
  to?: string
}

export function TabApp({ selectedValue, value, label, sx, ...props }: TabAppProps): ReactElement {
  return (
    <Tab
      value={value}
      sx={{
        textTransform: 'none',
        opacity: 1,
        '&:hover': { bgcolor: theme.palette.primary[25] },
        ...sx
      }}
      label={
        <Typography
          variant="body1"
          sx={value === selectedValue ? { fontWeight: 700 } : {}}
          color={value === selectedValue ? 'primary' : 'grey.500'}
        >
          {label}
        </Typography>
      }
      {...props}
    />
  )
}
